import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle2, XCircle, Loader2, ShieldCheck } from 'lucide-react';

// Pagina pubblica di verifica attestato tramite QR code: /verify/:code
export default function VerifyAttestatoPage() {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`/api/attestati/verifica/${code}`)
      .then((r) => setData(r.data))
      .catch(() => setData({ valid: false, message: 'Attestato non trovato' }))
      .finally(() => setLoading(false));
  }, [code]);

  const Row = ({ label, value }) => (
    value ? (
      <div className="flex justify-between gap-4 py-2 border-b border-slate-100" data-testid={`verify-row-${label}`}>
        <span className="text-sm text-slate-500">{label}</span>
        <span className="text-sm font-medium text-slate-900 text-right">{value}</span>
      </div>
    ) : null
  );

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="verify-attestato-page">
      <Card className="w-full max-w-lg shadow-lg">
        <CardHeader className="text-center border-b">
          <div className="flex items-center justify-center gap-2 text-slate-700">
            <ShieldCheck className="h-6 w-6" />
            <CardTitle className="text-lg">Verifica Attestato — CEN Engineering</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-6">
          {loading ? (
            <div className="flex flex-col items-center gap-3 py-10 text-slate-500" data-testid="verify-loading">
              <Loader2 className="h-8 w-8 animate-spin" />
              <span>Verifica in corso...</span>
            </div>
          ) : data?.valid ? (
            <div data-testid="verify-valid">
              <div className="flex flex-col items-center gap-2 mb-6">
                <CheckCircle2 className="h-16 w-16 text-green-600" />
                <span className="text-2xl font-bold text-green-700">ATTESTATO VALIDO</span>
                <span className="text-xs text-slate-400 font-mono">{data.code}</span>
              </div>
              <div className="space-y-0">
                <Row label="Nominativo" value={data.person_name} />
                <Row label="Codice fiscale" value={data.fiscal_code} />
                <Row label="Corso" value={data.course_name} />
                <Row label="Azienda" value={data.company} />
                <Row label="Mansione" value={data.mansione} />
                <Row label="Cod. ATECO" value={data.ateco} />
                <Row label="Data corso" value={data.course_date} />
                <Row label="Data fine" value={data.course_date_end} />
                <Row label="Scadenza" value={data.expiry_date} />
                <Row label="N. attestato" value={data.certificate_number} />
                <Row label="Emesso il" value={data.issued_at} />
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center gap-3 py-10" data-testid="verify-invalid">
              <XCircle className="h-16 w-16 text-red-600" />
              <span className="text-2xl font-bold text-red-700">NON VALIDO</span>
              <span className="text-sm text-slate-500">{data?.message || 'Attestato non riconosciuto'}</span>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
